import { useParams } from 'react-router-dom';

interface FeedbackParams {
    resourceId: string;
}

export function useFeedbackParams() {
    return useParams<FeedbackParams>();
}
